
import { AuthActions } from '@/store/modules/auth/enums';
import { Component, Vue } from 'vue-property-decorator';
import { MediasActions } from '@/store/modules/medias/enums';
import { MerchantConfig } from '@/models/config/merchantConfig';
import { MerchantConfigActions } from '@/store/modules/merchant-config/enums';
import { Routes } from '@/router/routes';
import { WebPaymentsActions } from '@/store/modules/web-payments/enums';
import Footer from '@/components/layout/Footer.vue';
import Header from '@/components/layout/Header.vue';
import HeaderBackground from '@/components/layout/HeaderBackground.vue';
import PrivacyContent from '@/views/privacy/PrivacyContent.vue';

@Component({
  components: {
    'ck-footer': Footer,
    'ck-header': Header,
    'ck-header-background': HeaderBackground,
    'ck-privacy-content': PrivacyContent,
  },
})
export default class Privacy extends Vue {
  protected isMobileAppRegistration = false;
  protected merchantConfig: MerchantConfig | undefined = undefined;
  protected show = true;

  private created(): void {
    this.isMobileAppRegistration = this.$route.params
      .isMobileAppRegistration as unknown as boolean;
    this.merchantConfig = this.$route.params
      .merchantCfg as unknown as MerchantConfig;
  }

  account(): void {
    this.$router.push({
      name: Routes.Customer,
      params: { loaded: 'true', showAccount: 'true' },
    });
  }

  async logout(): Promise<void> {
    this.show = false;
    this.$spinner.showSpinner();
    this.$store.dispatch(MerchantConfigActions.Clear);
    this.$store.dispatch(MediasActions.Clear);
    this.$store.dispatch(WebPaymentsActions.Clear);
    this.$store.dispatch(AuthActions.Logout);
    await this.$msal.signOut();
  }
}
